// GENERATED by mofsl-ekyc-backend/tools/error-catalog/gen_catalog.py -- do not edit.
// Source: tools/error-catalog/ekycv3_error_drop_code.xlsx (frontend + shared rows).

/** Frontend-raised catalogue codes (ekyc.error_code_catalog.error_code, source FE / BE_FE). */
export const ERROR_CATALOG = Object.freeze({
    GLOBAL_SESSION_SD_FE_01: 'GLOBAL_SESSION_SD_FE_01',
    GLOBAL_SESSION_SD_FE_03: 'GLOBAL_SESSION_SD_FE_03',
    GLOBAL_CLIPBOARD_ERR_FE_01: 'GLOBAL_CLIPBOARD_ERR_FE_01',
    GLOBAL_FILEUPLOAD_SD_FE_01: 'GLOBAL_FILEUPLOAD_SD_FE_01',
    GLOBAL_FILEUPLOAD_ERR_FE_02: 'GLOBAL_FILEUPLOAD_ERR_FE_02',
    GLOBAL_FILEUPLOAD_ERR_FE_03: 'GLOBAL_FILEUPLOAD_ERR_FE_03',
    GLOBAL_FILEUPLOAD_ERR_FE_04: 'GLOBAL_FILEUPLOAD_ERR_FE_04',
    GLOBAL_FILEUPLOAD_ERR_FE_05: 'GLOBAL_FILEUPLOAD_ERR_FE_05',
    GLOBAL_FILEUPLOAD_ERR_FE_06: 'GLOBAL_FILEUPLOAD_ERR_FE_06',
    GLOBAL_FILEUPLOAD_ERR_FE_07: 'GLOBAL_FILEUPLOAD_ERR_FE_07',
    GLOBAL_NETWORK_SD_FE_01: 'GLOBAL_NETWORK_SD_FE_01',
    GLOBAL_NETWORK_SD_FE_02: 'GLOBAL_NETWORK_SD_FE_02',
    GLOBAL_NETWORK_SD_FE_06: 'GLOBAL_NETWORK_SD_FE_06',
    GLOBAL_PARTNERCODE_SD_FE_01: 'GLOBAL_PARTNERCODE_SD_FE_01',
    REG_MOBILEOTP_SD_BE_FE_01: 'REG_MOBILEOTP_SD_BE_FE_01',
    REG_DOCCONSENT_ERR_FE_01: 'REG_DOCCONSENT_ERR_FE_01',
    REG_EMAIL_ERR_FE_01: 'REG_EMAIL_ERR_FE_01',
    REG_EMAIL_ERR_FE_02: 'REG_EMAIL_ERR_FE_02',
    REG_EMAIL_ERR_FE_03: 'REG_EMAIL_ERR_FE_03',
    REG_EMAIL_ERR_FE_04: 'REG_EMAIL_ERR_FE_04',
    REG_MOBILEOTP_ERR_FE_03: 'REG_MOBILEOTP_ERR_FE_03',
    REG_MOBILEOTP_ERR_FE_04: 'REG_MOBILEOTP_ERR_FE_04',
    REG_MOBILEOTP_ERR_FE_05: 'REG_MOBILEOTP_ERR_FE_05',
    REG_MOBILEOTP_ERR_FE_06: 'REG_MOBILEOTP_ERR_FE_06',
    REG_MOBILEOTP_ERR_FE_08: 'REG_MOBILEOTP_ERR_FE_08',
    REG_MOBILEOTP_ERR_FE_09: 'REG_MOBILEOTP_ERR_FE_09',
    REG_MOBILEOTP_ERR_FE_10: 'REG_MOBILEOTP_ERR_FE_10',
    REG_MOBILEOTP_ERR_FE_11: 'REG_MOBILEOTP_ERR_FE_11',
    REG_MOBILE_ERR_FE_01: 'REG_MOBILE_ERR_FE_01',
    REG_MOBILE_ERR_FE_02: 'REG_MOBILE_ERR_FE_02',
    REG_REFERRAL_SD_FE_02: 'REG_REFERRAL_SD_FE_02',
    REG_REFERRAL_ERR_FE_03: 'REG_REFERRAL_ERR_FE_03',
    REG_REGFORM_SD_FE_01: 'REG_REGFORM_SD_FE_01',
    REG_REGFORM_CF_FE_02: 'REG_REGFORM_CF_FE_02',
    REG_REGFORM_SD_FE_03: 'REG_REGFORM_SD_FE_03',
    REG_REGFORM_ERR_FE_04: 'REG_REGFORM_ERR_FE_04',
    REG_MOBILEOTP_ERR_BE_FE_01: 'REG_MOBILEOTP_ERR_BE_FE_01',
    EMAIL_ENTRY_SD_FE_05: 'EMAIL_ENTRY_SD_FE_05',
    EMAIL_ENTRY_SD_FE_06: 'EMAIL_ENTRY_SD_FE_06',
    EMAIL_GOOGLE_ERR_FE_01: 'EMAIL_GOOGLE_ERR_FE_01',
    EMAIL_GOOGLE_ERR_FE_02: 'EMAIL_GOOGLE_ERR_FE_02',
    EMAIL_GOOGLE_CF_FE_03: 'EMAIL_GOOGLE_CF_FE_03',
    EMAIL_GOOGLE_CF_FE_04: 'EMAIL_GOOGLE_CF_FE_04',
    EMAIL_GOOGLE_ERR_FE_05: 'EMAIL_GOOGLE_ERR_FE_05',
    EMAIL_OTPRESEND_ERR_FE_05: 'EMAIL_OTPRESEND_ERR_FE_05',
    EMAIL_OTPVERIFY_ERR_FE_06: 'EMAIL_OTPVERIFY_ERR_FE_06',
    EMAIL_OTPVERIFY_ERR_FE_08: 'EMAIL_OTPVERIFY_ERR_FE_08',
    EMAIL_OTPVERIFY_ERR_BE_FE_04: 'EMAIL_OTPVERIFY_ERR_BE_FE_04',
    EMAIL_OTPVERIFY_ERR_BE_FE_05: 'EMAIL_OTPVERIFY_ERR_BE_FE_05',
    PAN_CONFIRM_ERR_FE_01: 'PAN_CONFIRM_ERR_FE_01',
    PAN_CONFIRM_ERR_FE_04: 'PAN_CONFIRM_ERR_FE_04',
    PAN_DOC_CF_FE_01: 'PAN_DOC_CF_FE_01',
    PAN_DOC_ERR_FE_02: 'PAN_DOC_ERR_FE_02',
    PAN_ENTRY_SD_FE_03: 'PAN_ENTRY_SD_FE_03',
    PAN_ENTRY_CF_FE_05: 'PAN_ENTRY_CF_FE_05',
    PAN_ENTRY_ERR_FE_06: 'PAN_ENTRY_ERR_FE_06',
    PAN_ENTRY_ERR_FE_07: 'PAN_ENTRY_ERR_FE_07',
    PAN_ENTRY_ERR_FE_08: 'PAN_ENTRY_ERR_FE_08',
    PAN_VERIFY_CF_FE_09: 'PAN_VERIFY_CF_FE_09',
    PAN_VERIFY_ERR_FE_10: 'PAN_VERIFY_ERR_FE_10',
    AADHAAR_MANUALUPLOAD_ERR_FE_01: 'AADHAAR_MANUALUPLOAD_ERR_FE_01',
    BANK_BANKENTRY_ERR_FE_03: 'BANK_BANKENTRY_ERR_FE_03',
    BANK_BANKENTRY_ERR_FE_04: 'BANK_BANKENTRY_ERR_FE_04',
    BANK_BANKENTRY_ERR_FE_05: 'BANK_BANKENTRY_ERR_FE_05',
    BANK_BANKENTRY_ERR_FE_06: 'BANK_BANKENTRY_ERR_FE_06',
    BANK_BANKENTRY_ERR_FE_07: 'BANK_BANKENTRY_ERR_FE_07',
    BANK_BANKENTRY_ERR_FE_08: 'BANK_BANKENTRY_ERR_FE_08',
    BANK_BANKENTRY_ERR_FE_09: 'BANK_BANKENTRY_ERR_FE_09',
    BANK_BANKPROOF_ERR_FE_02: 'BANK_BANKPROOF_ERR_FE_02',
    BANK_BANKPROOF_ERR_FE_03: 'BANK_BANKPROOF_ERR_FE_03',
    BANK_BANKPROOF_ERR_FE_04: 'BANK_BANKPROOF_ERR_FE_04',
    BANK_IFSCLOOKUP_SD_FE_02: 'BANK_IFSCLOOKUP_SD_FE_02',
    BANK_PENNYDROP_ERR_FE_05: 'BANK_PENNYDROP_ERR_FE_05',
    BANK_PENNYDROP_ERR_FE_06: 'BANK_PENNYDROP_ERR_FE_06',
    BANK_PENNYDROP_ERR_FE_07: 'BANK_PENNYDROP_ERR_FE_07',
    BANK_PENNYDROP_ERR_FE_56: 'BANK_PENNYDROP_ERR_FE_56',
    BANK_PENNYDROP_ERR_FE_57: 'BANK_PENNYDROP_ERR_FE_57',
    LIVENESS_PREVIEW_ERR_FE_01: 'LIVENESS_PREVIEW_ERR_FE_01',
    LIVENESS_PREVIEW_ERR_FE_02: 'LIVENESS_PREVIEW_ERR_FE_02',
    PERSONAL_FORM_ERR_FE_01: 'PERSONAL_FORM_ERR_FE_01',
    PERSONAL_FORM_ERR_FE_06: 'PERSONAL_FORM_ERR_FE_06',
    PERSONAL_FORM_ERR_FE_07: 'PERSONAL_FORM_ERR_FE_07',
    PERSONAL_FORM_ERR_FE_08: 'PERSONAL_FORM_ERR_FE_08',
    PERSONAL_FORM_ERR_FE_09: 'PERSONAL_FORM_ERR_FE_09',
    PERSONAL_FORM_ERR_FE_10: 'PERSONAL_FORM_ERR_FE_10',
    PERSONAL_FORM_ERR_FE_11: 'PERSONAL_FORM_ERR_FE_11',
    PERSONAL_FORM_ERR_FE_12: 'PERSONAL_FORM_ERR_FE_12',
    PERSONAL_FORM_ERR_FE_13: 'PERSONAL_FORM_ERR_FE_13',
    PERSONAL_FORM_ERR_FE_14: 'PERSONAL_FORM_ERR_FE_14',
    PERSONAL_FORM_ERR_FE_15: 'PERSONAL_FORM_ERR_FE_15',
    PERSONAL_FORM_ERR_FE_16: 'PERSONAL_FORM_ERR_FE_16',
    PERSONAL_FORM_ERR_FE_17: 'PERSONAL_FORM_ERR_FE_17',
    NOMINEE_ADDRESS_ERR_FE_01: 'NOMINEE_ADDRESS_ERR_FE_01',
    NOMINEE_ADDRESS_ERR_FE_02: 'NOMINEE_ADDRESS_ERR_FE_02',
    NOMINEE_ADDRESS_ERR_FE_03: 'NOMINEE_ADDRESS_ERR_FE_03',
    NOMINEE_ADDRESS_ERR_FE_04: 'NOMINEE_ADDRESS_ERR_FE_04',
    NOMINEE_ADDRESS_ERR_FE_05: 'NOMINEE_ADDRESS_ERR_FE_05',
    NOMINEE_ADDRESS_ERR_FE_06: 'NOMINEE_ADDRESS_ERR_FE_06',
    NOMINEE_ALLOCATION_ERR_FE_04: 'NOMINEE_ALLOCATION_ERR_FE_04',
    NOMINEE_ALLOCATION_ERR_FE_05: 'NOMINEE_ALLOCATION_ERR_FE_05',
    NOMINEE_DETAILS_ERR_FE_01: 'NOMINEE_DETAILS_ERR_FE_01',
    NOMINEE_DETAILS_ERR_FE_02: 'NOMINEE_DETAILS_ERR_FE_02',
    NOMINEE_DETAILS_ERR_FE_03: 'NOMINEE_DETAILS_ERR_FE_03',
    NOMINEE_DETAILS_ERR_FE_04: 'NOMINEE_DETAILS_ERR_FE_04',
    NOMINEE_DETAILS_ERR_FE_16: 'NOMINEE_DETAILS_ERR_FE_16',
    NOMINEE_DETAILS_ERR_FE_17: 'NOMINEE_DETAILS_ERR_FE_17',
    NOMINEE_DETAILS_ERR_FE_18: 'NOMINEE_DETAILS_ERR_FE_18',
    NOMINEE_DETAILS_ERR_FE_19: 'NOMINEE_DETAILS_ERR_FE_19',
    NOMINEE_DETAILS_ERR_FE_20: 'NOMINEE_DETAILS_ERR_FE_20',
    NOMINEE_DETAILS_ERR_FE_21: 'NOMINEE_DETAILS_ERR_FE_21',
    NOMINEE_DETAILS_ERR_FE_22: 'NOMINEE_DETAILS_ERR_FE_22',
    NOMINEE_DETAILS_ERR_FE_23: 'NOMINEE_DETAILS_ERR_FE_23',
    NOMINEE_DETAILS_ERR_FE_24: 'NOMINEE_DETAILS_ERR_FE_24',
    NOMINEE_DETAILS_ERR_FE_25: 'NOMINEE_DETAILS_ERR_FE_25',
    NOMINEE_GUARDIAN_ERR_FE_04: 'NOMINEE_GUARDIAN_ERR_FE_04',
    NOMINEE_GUARDIAN_ERR_FE_05: 'NOMINEE_GUARDIAN_ERR_FE_05',
    NOMINEE_IDPROOF_ERR_FE_01: 'NOMINEE_IDPROOF_ERR_FE_01',
    NOMINEE_IDPROOF_ERR_FE_02: 'NOMINEE_IDPROOF_ERR_FE_02',
    NOMINEE_IDPROOF_ERR_FE_03: 'NOMINEE_IDPROOF_ERR_FE_03',
    NOMINEE_PAN_ERR_FE_07: 'NOMINEE_PAN_ERR_FE_07',
    NOMINEE_PAN_ERR_FE_08: 'NOMINEE_PAN_ERR_FE_08',
    NOMINEE_PAN_ERR_FE_09: 'NOMINEE_PAN_ERR_FE_09',
    NOMINEE_PAN_ERR_FE_10: 'NOMINEE_PAN_ERR_FE_10',
    INCOME_UPLOAD_ERR_FE_01: 'INCOME_UPLOAD_ERR_FE_01',
    INCOME_UPLOAD_ERR_FE_02: 'INCOME_UPLOAD_ERR_FE_02',
    INCOME_UPLOAD_ERR_FE_03: 'INCOME_UPLOAD_ERR_FE_03',
    INCOME_UPLOAD_ERR_FE_04: 'INCOME_UPLOAD_ERR_FE_04',
    INCOME_UPLOAD_ERR_FE_05: 'INCOME_UPLOAD_ERR_FE_05',
    INCOME_UPLOAD_ERR_FE_06: 'INCOME_UPLOAD_ERR_FE_06',
    ESIGN_COMPLETION_SD_FE_01: 'ESIGN_COMPLETION_SD_FE_01',
    ESIGN_DLCONSENT_ERR_FE_01: 'ESIGN_DLCONSENT_ERR_FE_01',
    ESIGN_DLINIT_ERR_FE_01: 'ESIGN_DLINIT_ERR_FE_01',
    ESIGN_DLVERIFY_ERR_FE_01: 'ESIGN_DLVERIFY_ERR_FE_01',
    ESIGN_DLVERIFY_ERR_FE_02: 'ESIGN_DLVERIFY_ERR_FE_02',
    ESIGN_POPUP_ERR_FE_01: 'ESIGN_POPUP_ERR_FE_01',
});

/** Exact user-facing message (whitespace-normalised) -> catalogue code, for display-time resolution. */
export const MESSAGE_TO_CODE = Object.freeze({
    'Account number is required': 'BANK_BANKENTRY_ERR_FE_04',
    'Allow pop-up blocker in the browser.': 'ESIGN_POPUP_ERR_FE_01',
    'An unexpected error occurred. Please try again.': 'REG_REGFORM_SD_FE_01',
    'At least 5 characters required': 'NOMINEE_ADDRESS_ERR_FE_04',
    'Bank proof deleted successfully.': 'BANK_BANKPROOF_ERR_FE_02',
    'Could not load PAN details. Please try again.': 'PAN_ENTRY_SD_FE_03',
    'Could not look up that IFSC. Please check and try again.': 'BANK_IFSCLOOKUP_SD_FE_02',
    'Could not verify email via Google. Please try again.': 'EMAIL_GOOGLE_ERR_FE_05',
    'DigiLocker process failed': 'ESIGN_DLVERIFY_ERR_FE_01',
    'DigiLocker session could not be initiated. Please try again.': 'ESIGN_DLINIT_ERR_FE_01',
    'Digilocker flow not completed! .': 'ESIGN_DLVERIFY_ERR_FE_02',
    'Don\'t worry you can add your account manually': 'BANK_PENNYDROP_ERR_FE_56',
    'Email must be less than 100 characters': 'REG_EMAIL_ERR_FE_04',
    'Enter a valid IFSC code (e.g. HDFC0001234)': 'BANK_BANKENTRY_ERR_FE_06',
    'Enter complete 4-digit OTP': 'EMAIL_OTPVERIFY_ERR_FE_06',
    'Error copying to clipboard': 'GLOBAL_CLIPBOARD_ERR_FE_01',
    'Error fetching DIY details': 'GLOBAL_NETWORK_SD_FE_02',
    'Error occurred while validating referral code': 'REG_REFERRAL_SD_FE_02',
    'Failed to fetch email. Please try again.': 'EMAIL_ENTRY_SD_FE_05',
    'Failed to send OTP. Please try again.': 'EMAIL_ENTRY_SD_FE_06',
    'File Size is more than X MB.': 'INCOME_UPLOAD_ERR_FE_01',
    'File size must be under 5 MB.': 'GLOBAL_FILEUPLOAD_ERR_FE_02',
    'Google returned an invalid email. Please enter manually.': 'EMAIL_GOOGLE_ERR_FE_02',
    'Google sign-in did not return an email. Please enter manually.': 'EMAIL_GOOGLE_ERR_FE_01',
    'Hey, your session has expired due to inactivity. Please Re-Login to continue your Demat account application.': 'GLOBAL_SESSION_SD_FE_03',
    'IFSC code is required': 'BANK_BANKENTRY_ERR_FE_07',
    'If ₹1 Rupee was debited will be refunded within 3 working days': 'BANK_PENNYDROP_ERR_FE_57',
    'Income-proof upload failed. Please try again.': 'INCOME_UPLOAD_ERR_FE_03',
    'Invalid Partner Code': 'GLOBAL_PARTNERCODE_SD_FE_01',
    'Invalid Pincode': 'NOMINEE_ADDRESS_ERR_FE_06',
    'Invalid file type. Please upload JPEG, PNG, or PDF.': 'GLOBAL_FILEUPLOAD_ERR_FE_05',
    'Maximum 11 characters allowed': 'BANK_BANKENTRY_ERR_FE_08',
    'Maximum 20 digits allowed': 'BANK_BANKENTRY_ERR_FE_05',
    'Network error. Please check your connection and try again.': 'GLOBAL_NETWORK_SD_FE_06',
    'Note: If bank verification fails, try using different bank account details.': 'BANK_BANKENTRY_ERR_FE_09',
    'OTP entered is incorrect': 'REG_MOBILEOTP_ERR_FE_03',
    'OTP entered is incorrect.': 'EMAIL_OTPVERIFY_ERR_BE_FE_04',
    'OTP expired. Please request a new one.': 'EMAIL_OTPVERIFY_ERR_BE_FE_05',
    'OTP must be of 4 digits': 'REG_MOBILEOTP_ERR_FE_04',
    'OTP must contain only numbers': 'REG_MOBILEOTP_ERR_FE_09',
    'Only JPG, PDF, PNG files are allowed to upload': 'GLOBAL_FILEUPLOAD_ERR_FE_04',
    'Only image files(.png, .jpg etc) allowed. Word docs not allowed': 'GLOBAL_FILEUPLOAD_ERR_FE_06',
    'Only numbers are allowed': 'BANK_BANKENTRY_ERR_FE_03',
    'Please Enter PAN': 'PAN_ENTRY_ERR_FE_07',
    'Please Enter Valid PAN': 'PAN_ENTRY_ERR_FE_08',
    'Please Upload a Clear Image, Reupload if not clear': 'LIVENESS_PREVIEW_ERR_FE_01',
    'Please accept all required consents to proceed': 'REG_REGFORM_ERR_FE_04',
    'Please add nominee': 'NOMINEE_DETAILS_ERR_FE_22',
    'Please draw signature': 'INCOME_UPLOAD_ERR_FE_05',
    'Please ensure your Aadhaar has QR code either in front or back. If not then please download the latest Aadhaar with QR code from UIDAI website': 'AADHAAR_MANUALUPLOAD_ERR_FE_01',
    'Please enter Aadhaar': 'NOMINEE_IDPROOF_ERR_FE_01',
    'Please enter Address': 'NOMINEE_ADDRESS_ERR_FE_01',
    'Please enter Address Line 1': 'NOMINEE_ADDRESS_ERR_FE_02',
    'Please enter Address Line 2': 'NOMINEE_ADDRESS_ERR_FE_03',
    'Please enter Date of Birth': 'NOMINEE_DETAILS_ERR_FE_16',
    'Please enter Driving License': 'NOMINEE_IDPROOF_ERR_FE_02',
    'Please enter First name': 'NOMINEE_DETAILS_ERR_FE_18',
    'Please enter Full Name': 'NOMINEE_DETAILS_ERR_FE_19',
    'Please enter Last Name': 'NOMINEE_DETAILS_ERR_FE_21',
    'Please enter Nominee\'s email.': 'NOMINEE_DETAILS_ERR_FE_17',
    'Please enter Nominee\'s mobile number': 'NOMINEE_DETAILS_ERR_FE_23',
    'Please enter Nominee\'s share': 'NOMINEE_ALLOCATION_ERR_FE_04',
    'Please enter OTP': 'REG_MOBILEOTP_ERR_FE_05',
    'Please enter Pincode': 'NOMINEE_ADDRESS_ERR_FE_05',
    'Please enter a different bank account, or upload bank proof if you wish to continue with the same bank account.': 'BANK_PENNYDROP_ERR_FE_06',
    'Please enter a valid Email ID': 'REG_EMAIL_ERR_FE_01',
    'Please enter a valid PAN': 'NOMINEE_PAN_ERR_FE_10',
    'Please enter a valid mobile number': 'REG_MOBILE_ERR_FE_01',
    'Please enter correct PAN for nominee 1': 'NOMINEE_PAN_ERR_FE_07',
    'Please enter correct PAN for nominee 2': 'NOMINEE_PAN_ERR_FE_08',
    'Please enter correct PAN for nominee 3': 'NOMINEE_PAN_ERR_FE_09',
    'Please enter the OTP sent to your Email ID': 'REG_EMAIL_ERR_FE_02',
    'Please enter the OTP sent to your mobile number': 'REG_MOBILEOTP_ERR_FE_11',
    'Please enter the valid OTP sent to your Email ID': 'EMAIL_OTPVERIFY_ERR_FE_08',
    'Please enter the valid OTP sent to your mobile number': 'REG_MOBILEOTP_ERR_FE_10',
    'Please enter valid Date of Birth': 'NOMINEE_DETAILS_ERR_FE_25',
    'Please enter valid Email Id': 'NOMINEE_GUARDIAN_ERR_FE_04',
    'Please enter valid Mobile Number': 'NOMINEE_GUARDIAN_ERR_FE_05',
    'Please enter valid Nominee Percentage (%)': 'NOMINEE_ALLOCATION_ERR_FE_05',
    'Please enter valid Referral Code': 'REG_REFERRAL_ERR_FE_03',
    'Please enter your Email ID': 'REG_EMAIL_ERR_FE_03',
    'Please enter your Mobile Number': 'REG_MOBILE_ERR_FE_02',
    'Please enter your full name as per PAN': 'PAN_ENTRY_ERR_FE_06',
    'Please install an external webcam device.': 'INCOME_UPLOAD_ERR_FE_06',
    'Please select Commodity': 'PERSONAL_FORM_ERR_FE_09',
    'Please select Cycle': 'PERSONAL_FORM_ERR_FE_10',
    'Please select DIS': 'PERSONAL_FORM_ERR_FE_08',
    'Please select DpId': 'PERSONAL_FORM_ERR_FE_11',
    'Please select Education Qualification': 'PERSONAL_FORM_ERR_FE_12',
    'Please select Income': 'PERSONAL_FORM_ERR_FE_13',
    'Please select MTF': 'PERSONAL_FORM_ERR_FE_16',
    'Please select Marital Status': 'PERSONAL_FORM_ERR_FE_14',
    'Please select Mode Of Operations': 'PERSONAL_FORM_ERR_FE_15',
    'Please select Nominee\'s Gender': 'NOMINEE_DETAILS_ERR_FE_20',
    'Please select Politically Exposed Status': 'PERSONAL_FORM_ERR_FE_17',
    'Please select Proof type': 'NOMINEE_IDPROOF_ERR_FE_03',
    'Please select all fields': 'PERSONAL_FORM_ERR_FE_06',
    'Please select any Option': 'PERSONAL_FORM_ERR_FE_07',
    'Please select your relationship with Nominee': 'NOMINEE_DETAILS_ERR_FE_24',
    'Please upload an income-proof document before proceeding.': 'INCOME_UPLOAD_ERR_FE_02',
    'Please wait before requesting another OTP.': 'REG_MOBILEOTP_ERR_BE_FE_01',
    'Session Expired': 'GLOBAL_SESSION_SD_FE_01',
    'Session expired. Please re-register.': 'REG_REGFORM_SD_FE_03',
    'Too many failed attempts. Please request a new OTP.': 'REG_MOBILEOTP_ERR_FE_06',
    'Too many resend attempts. Please try later.': 'REG_MOBILEOTP_SD_BE_FE_01',
    'Uploaded document will be deleted. Do you still want to proceed ?': 'REG_DOCCONSENT_ERR_FE_01',
    'We apologize for the inconvenience, unable to process your request. Please re try.': 'GLOBAL_NETWORK_SD_FE_01',
    'We are going to take first X page and discard remaining': 'INCOME_UPLOAD_ERR_FE_04',
    'We could not verify that bank proof. Please upload a clearer document.': 'BANK_BANKPROOF_ERR_FE_03',
    'We could not verify your PAN details. Please re-check your PAN, name and date of birth and try again.': 'PAN_VERIFY_ERR_FE_10',
    'We couldn\'t verify your bank details !': 'BANK_PENNYDROP_ERR_FE_07',
    'We\'re unable to verify your Client Code at this time. Please try again.': 'ESIGN_COMPLETION_SD_FE_01',
    'You have denied DigiLocker consent. Please allow consent to continue.': 'ESIGN_DLCONSENT_ERR_FE_01',
    'Your name in bank does not match with PAN': 'BANK_PENNYDROP_ERR_FE_05',
    'authorizeNomineeError': 'NOMINEE_DETAILS_ERR_FE_01',
    'consentError': 'PAN_CONFIRM_ERR_FE_01',
    'nomineeBottomSheetError': 'NOMINEE_DETAILS_ERR_FE_03',
    'nomineeMandatory': 'NOMINEE_DETAILS_ERR_FE_02',
    'otpError': 'REG_MOBILEOTP_ERR_FE_08',
    'personalError.isIndian': 'PERSONAL_FORM_ERR_FE_01',
    'printDetailsError': 'NOMINEE_DETAILS_ERR_FE_04',
    'rejectionMessage': 'PAN_CONFIRM_ERR_FE_04',
});

